const colors = {
    success: {
        border: "border-green-400",
        bg: "bg-green-50",
        text: "text-green-700",
    },
    warning: {
        border: "border-yellow-400",
        bg: "bg-yellow-50",
        text: "text-yellow-700",
    },
    danger: {
        border: "border-red-400",
        bg: "bg-red-50",
        text: "text-red-700",
    },
    default: {
        border: "border-gray-400",
        bg: "bg-gray-50",
        text: "text-gray-700",
    },
};

interface AlertWithAccentBorderInterface {
    type: keyof typeof colors;
    children: any;
    className?: string;
}

export default function AlertWithAccentBorder({
    type,
    children,
    className = "",
}: AlertWithAccentBorderInterface) {
    return (
        <div
            className={`border-l-4 ${
                (colors?.[type] || colors.default).border
            } ${(colors?.[type] || colors.default).bg} p-4 ${className}`}
        >
            <div className="flex">
                <div className="ml-3">
                    <p
                        className={`text-sm ${
                            (colors?.[type] || colors.default).text
                        }`}
                    >
                        {children}
                    </p>
                </div>
            </div>
        </div>
    );
}
